// src/routes/ProjectDetailPage.js
import React from "react";
import { useParams } from "react-router-dom";
import { FaExternalLinkAlt, FaSpinner } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import DetailLayout from "../components/DetailLayout";
import { useData } from "../hooks/useData";
import { getProjectById } from "../firebase/dataService";

const ProjectDetailPage = () => {
  const { id } = useParams();
  const { data: project, loading, error } = useData(() => getProjectById(id), [id]);

  return (
    <div>
      <Navbar />
      {loading ? (
        <div className="container" style={{ padding: "9rem 0", textAlign: "center" }}>
          <FaSpinner className="spin" size={22} />
        </div>
      ) : error || !project ? (
        <div className="container" style={{ padding: "9rem 0", textAlign: "center" }}>
          <p style={{ color: "var(--text-2)" }}>Project not found.</p>
        </div>
      ) : (
        <DetailLayout
          backTo="/projects"
          backLabel="All projects"
          coverImage={project.imgsrc}
          eyebrow="Project"
          title={project.title}
          meta={[
            project.date,
            project.stack && (
              <span key="stack" style={{ color: "var(--text-2)" }}>{project.stack}</span>
            ),
          ].filter(Boolean)}
          cta={
            project.view && project.view !== "#" && (
              <a href={project.view} target="_blank" rel="noreferrer" className="btn btn-primary">
                View project <FaExternalLinkAlt size={12} />
              </a>
            )
          }
        >
          <p>{project.text}</p>
          {Array.isArray(project.bullets) && project.bullets.length > 0 && (
            <ul style={{ marginTop: "1.5rem", paddingLeft: "1.25rem", display: "flex", flexDirection: "column", gap: "0.6rem" }}>
              {project.bullets.map((b, i) => <li key={i}>{b}</li>)}
            </ul>
          )}
        </DetailLayout>
      )}
      <Footer />
    </div>
  );
};

export default ProjectDetailPage;
